import { Collapse } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import classNames from './styles.module.scss'


export default function CollapsePanel(props) {
  return (
    <Collapse
      bordered={false}
      expandIcon={({ isActive }) => <FontAwesomeIcon className={classNames.icon} icon={!isActive ? 'caret-down' : 'caret-up'} />}
      expandIconPosition="right"
      className={classNames.collapse}
      {...props}
    />
  )
}
